@import 'styles/blaze/mixins';

.moreOptionsContainer {
  margin: 20px 0 70px 0;
}

.clearFormatButton {
  @include blur(35px);
  margin-left: -15px;
  position: fixed;
  bottom: 0;
  width: 100%;
  background: var(--light-60);
  box-shadow: 1px 1px 0px 0px var(--light-90) inset, 0px 2px 12px 0px var(--dark-4);
  padding: 15px;
}
